<template>
  <a-drawer
    :title="$t('fournisseur.invoiceSummary')"
    :width="680"
    :visible="visible"
    @close="$emit('close')"
    destroy-on-close
  >
    <template v-if="depense">
      <a-descriptions :column="2" bordered size="small" class="mb-4">
        <a-descriptions-item :label="$t('decaissement.invoiceNumber')">
          {{ depense.invoiceNumber || depense.reference || "—" }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('decaissement.invoiceDate')">
          {{ formatDate(depense.date) }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('decaissement.depenseCreatedAt')">
          {{ formatDate(depense.entryDate || depense.createdAt) }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('fournisseur.totalAmount')">
          {{ (depense._totalAmount || 0).toFixed(3) }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('fournisseur.totalPaid')">
          {{ (depense._totalPaid || 0).toFixed(3) }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('fournisseur.remaining')" :span="2">
          <strong>{{ (depense._remaining || 0).toFixed(3) }}</strong>
        </a-descriptions-item>
      </a-descriptions>

      <depense-schedules-panel :depense="depense" @refresh="$emit('refresh')" />

      <template v-if="depense.direction === 'inverse'">
        <a-divider />
        <inverse-schedules-panel :depense="depense" @refresh="$emit('refresh')" />
      </template>
    </template>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import DepenseSchedulesPanel from './DepenseSchedulesPanel.vue'
import InverseSchedulesPanel from './InverseSchedulesPanel.vue'

export default {
  name: 'ScheduleDrawer',
  components: { DepenseSchedulesPanel, InverseSchedulesPanel },
  props: {
    visible: { type: Boolean, default: false },
    depense: { type: Object, default: null },
  },
  methods: {
    formatDate(val) {
      return val ? moment(val).format('DD/MM/YYYY') : '—'
    },
    formatDateTime(val) {
      return val ? moment(val).format('DD/MM/YYYY HH:mm') : '—'
    },
  },
}
</script>
